<div class="flex-column justify-content-between align-items-center">
  <div class="d-flex w-100 justify-content-between">
    <div class="flexStart">
      @if (deviceAuthenticator().type === 'PHONE') {
        <fa-icon icon="mobile-alt" size="3x"
                 class="ms-2 me-2 vid-fa-icon-black"></fa-icon>
      } @else if (deviceAuthenticator().type === 'DESKTOP') {
        <fa-icon icon="computer" size="3x"
                 class="ms-2 me-2 vid-fa-icon-black"></fa-icon>
      }

      <div>
        <span class="section-title">{{ deviceAuthenticator().commercialName || deviceAuthenticator().name }}
        </span>
        <div>
          <div class="row">
            <div class="col" [ngSwitch]="deviceAuthenticator().status">
              <span *ngSwitchCase="'ACTIVATED'"
                    class="vid-badge badge bg-success ng-star-inserted">{{ 'AUTHENTICATORS.STATUS_' + deviceAuthenticator().status | translate }}</span>
              <span *ngSwitchCase="'BLOCKED_BY_OWNER'"
                    class="vid-badge badge bg-danger ng-star-inserted">{{ 'AUTHENTICATORS.STATUS_' + deviceAuthenticator().status | translate }}</span>
              <span *ngSwitchCase="'BLOCKED_BY_ADMIN'"
                    class="vid-badge badge bg-danger ng-star-inserted">{{ 'AUTHENTICATORS.STATUS_' + deviceAuthenticator().status | translate }}</span>
              <span *ngSwitchDefault
                    class="vid-badge badge bg-secondary ng-star-inserted">{{ deviceAuthenticator().status }}</span>
            </div>
            <div class="col ms-0 ps-0" *ngIf="deviceAuthenticator().dormant" [hidden]="">
              <div class="vid-badge badge bg-warning text-dark">
                <img src='assets/nucleo/icons8-sleep-16.png' width="13" height="13">
                <span
                  style="font-size: 10px; font-style: italic; padding-left: 5px">{{ 'AUTHENTICATORS.DORMANT_MESSAGE' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button id="blockDeviceBtn" (click)="onBlockDevice(deviceAuthenticator())"
              *ngIf="deviceAuthenticator().status == 'ACTIVATED'"
              type="button"
              class="vid-btn vid-btn-orange vid-btn-sm me-2">{{ 'AUTHENTICATORS.BLOCK_DEVICE' | translate }}
      </button>
      <button id="unblockDeviceBtn" (click)="onUnblockDevice(deviceAuthenticator())"
              *ngIf="deviceAuthenticator().status == 'BLOCKED_BY_OWNER'"
              type="button"
              class="vid-btn vid-btn-green vid-btn-sm me-2">{{ 'AUTHENTICATORS.UNBLOCK_DEVICE' | translate }}
      </button>
      @if (deviceAuthenticator().type !== 'DESKTOP') {
        <button id="removeDeviceBtn" (click)="onRemoveDevice(deviceAuthenticator())"
                *ngIf="!hideRemoveAuthenticatorsButton()"
                type="button"
                class="vid-btn vid-btn-red vid-btn-sm">{{ 'AUTHENTICATORS.REMOVE_DEVICE' | translate }}
        </button>
      }
    </div>
  </div>
  <div class="mt-4 list-group list-group-flush ms-3 me-3">
    <div class="list-group-item list-group-item-action">
      <div class="flex-column justify-content-between align-items-center">
        <div class="d-flex w-100 justify-content-between">
          <span class="vid-list-item-title">{{ 'AUTHENTICATORS.DEVICE_ID' | translate }}</span>
          <span class="vid-list-item-description">{{ deviceAuthenticator().id }}</span>
        </div>
      </div>
    </div>
    <div class="list-group-item list-group-item-action">
      <div class="flex-column justify-content-between align-items-center">
        <div class="d-flex w-100 justify-content-between">
          <span class="vid-list-item-title">{{ 'AUTHENTICATORS.DEVICE_OS' | translate }}</span>
          <span
            class="vid-list-item-description badge bg-secondary">{{ deviceAuthenticator().os }}</span>
        </div>
      </div>
    </div>
    <div class="list-group-item list-group-item-action">
      <div class="flex-column justify-content-between align-items-center">
        <div class="d-flex w-100 justify-content-between">
          <span class="vid-list-item-title">{{ 'AUTHENTICATORS.DEVICE_TYPE' | translate }}</span>
          <span
            class="vid-list-item-description badge bg-secondary">{{ deviceAuthenticator().type }}</span>
        </div>
      </div>
    </div>
    <div class="list-group-item list-group-item-action">
      <div class="flex-column justify-content-between align-items-center">
        <div class="d-flex w-100 justify-content-between">
          <span class="vid-list-item-title">{{ 'AUTHENTICATORS.DEVICE_REG_TIME' | translate }}</span>
          <span
            class="vid-list-item-description badge bg-secondary">{{ deviceAuthenticator().registrationDate | isoDate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3 ms-4">
    <span class="section-title">{{ 'AUTHENTICATORS.AUTHENTICATORS' | translate }}</span>
  </div>
</div>
<div class="mt-3 mb-3 ms-4 me-4">

  <ngx-datatable class="fullscreen" [columnMode]="ColumnMode.flex" [headerHeight]="30"
                 [footerHeight]="80" rowHeight="auto" [rows]="deviceAuthenticator().authenticators"
                 [selectionType]="SelectionType.single">
    <ngx-datatable-column [flexGrow]="2" name="" prop="type" [sortable]="false">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <div class="pt-2 pb-1 fs-7">
          @switch (iconMapping()[value]?.type) {
            @case ("icon") {
              <fa-icon [icon]="iconMapping()[value]?.icon" size="3x"
                       class="vid-fa-icon-black m1"
                       [ngStyle]="iconMapping()[value]?.style"></fa-icon>
            }
            @case ("image") {
              <img [src]="iconMapping()[value]?.src" class="fido_logo"/>
            }
          }
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.TYPE' | translate" prop="type">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <div class="mt-2">
          <span>{{ 'AUTHENTICATORS.' + row.type | translate }}</span>
          <span *ngIf="row.type==='FIDO'">{{ row.fidoCalculatedName }}</span>
          <span
            *ngIf="row.type ==='SW_OTP' || row.type === 'HW_OTP'">{{ ' - ' + row.name }}</span>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.STATUS' | translate" prop="status">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div style="display: flex">
          <div>
              <span
                *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value==='ACTIVATED'"
                class="mt-2 vid-badge badge bg-success">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value==='LOST'"
              class="mt-2 vid-badge badge bg-danger">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value==='EXPIRED'"
              class="mt-2 vid-badge badge bg-warning text-dark">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              tooltip="{{'AUTHENTICATORS.STATUS_EXPIRING_EXPLANATION' | translate: {days: row.details['expiringInDays']} }}"
              container="body" [adaptivePosition]="false" placement="top"
              *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value==='EXPIRING'"
              class="mt-2 vid-badge badge bg-warning text-dark">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value==='DISABLED'"
              class="mt-2 vid-badge badge bg-secondary">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              *ngIf="deviceAuthenticator().status == 'ACTIVATED' && value ==='BLOCKED_BY_ADMIN'"
              class="mt-2 vid-badge badge bg-danger">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
            <span
              *ngIf="deviceAuthenticator().status !== 'ACTIVATED'"
              class="mt-2 vid-badge badge bg-warning text-dark">{{ deviceAuthenticator().status }}</span>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="4" [name]="'AUTHENTICATORS.REG_TIME' | translate"
                          prop="registrationDate">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div class="mt-2">
          {{ value | isoDateTime }}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.ACTIONS' | translate" prop="id"
                          [sortable]="false">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        @if (row.type === 'PIN' && deviceAuthenticator().status != 'BLOCKED_BY_ADMIN') {
          <button id="resetPinBtn"
                  (click)="resetPin()" type="button"
                  class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.RESET' | translate }}
          </button>
        }

        @if (row.type === 'ENTRA_PASSKEY') {
          <button id="syncPasskeyBtn"
                  (click)="syncPasskeys(deviceAuthenticator().id)" type="button"
                  class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.VALIDATE_PASSKEY' | translate }}
          </button>
        }

        @if (row.type === 'WBF' && !hideRemoveAuthenticatorsButton() && row.status !== 'BLOCKED_BY_ADMIN') {
          <button id="removeAuthBtn"
                  (click)="removeAuth(row)" type="button"
                  class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.REMOVE' | translate }}
          </button>
        }

      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
